import { Typography } from "@material-ui/core"

const Occasions = (props) => {

  return ( <>
    <Typography>
      Yep! That’s just how we started out, but we can make songs to celebrate any occasion. Bachelorette party? Definitely! Road trip anthem? Absolutely! A heartfelt tribute to your pet lizard, Steve? We’re on it. Whether it’s an inside joke, a birthday, or just a song about how much you love tacos, we’ve got you covered.
    </Typography>
  </> )
}

export default Occasions
